import React from 'react';
import JUNOButton from '../JUNOButton';
import { motion } from 'framer-motion';
import './style.scss';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import { callbackify } from 'util';

interface DownLoadsComponentProps {
  currentUser: object;
  content: object;
  dateObject: object;
  firehoseAnalytics: Function;
  reportActivity: Function;
}

const DownloadsComponent: React.FC<DownLoadsComponentProps> = ({
  currentUser,
  firehoseAnalytics,
  reportActivity,
  content,
  dateObject,
}) => {
  const downloadButtonsData = [
    {
      filename: encodeURI(content.Name) + '_UniqueUsersReport.csv',
      category: 'Unique Users',
      upsrc: Resources.resources.ICON_DOWNLOAD.src,
      buttonStyle: 'juno_button juno_button_filled juno_text_uppercase',
      endpoint: CrowdHub_App.CONFIG.BASE_URL + 'custom_api/api_analytics_exportUniqueUsers.php',
      text: CrowdHub_App.LANG.DOWNLOAD_USERS_BUTTON,
    },
    {
      filename: encodeURI(content.Name) + '_ActivityReport.csv',
      category: 'Activity',
      upsrc: Resources.resources.ICON_DOWNLOAD.src,
      buttonStyle: 'juno_button juno_button_filled juno_text_uppercase',
      endpoint: CrowdHub_App.CONFIG.BASE_URL + 'custom_api/api_analytics_exportActivityLog.php',
      text: CrowdHub_App.LANG.DOWNLOAD_ACTIVITY_BUTTON,
    },
    {
      filename: encodeURI(content.Name) + '_PollResponsesReport.csv',
      category: 'Responses',
      upsrc: Resources.resources.ICON_DOWNLOAD.src,
      buttonStyle: 'juno_button juno_button_filled juno_text_uppercase',
      endpoint: CrowdHub_App.CONFIG.BASE_URL + 'custom_api/api_analytics_exportPollLog.php',
      text: CrowdHub_App.LANG.DOWNLOAD_RESPONSES,
    },
    {
      filename: encodeURI(content.Name) + '_DownloadsReport.csv',
      category: 'Downloads',
      upsrc: Resources.resources.ICON_DOWNLOAD.src,
      buttonStyle: 'juno_button juno_button_filled juno_text_uppercase',
      endpoint: CrowdHub_App.CONFIG.BASE_URL + 'custom_api/api_analytics_exportActivityLog.php',
      text: CrowdHub_App.LANG.DOWNLOAD_DOWNLOADS,
    },
    {
      filename: encodeURI(content.Name) + '_ClicksReport.csv',
      category: 'Clicks',
      upsrc: Resources.resources.ICON_DOWNLOAD.src,
      buttonStyle: 'juno_button juno_button_filled juno_text_uppercase',
      endpoint: CrowdHub_App.CONFIG.BASE_URL + 'custom_api/api_analytics_exportActivityLog.php',
      text: CrowdHub_App.LANG.DOWNLOAD_META,
    },
    {
      filename: encodeURI(content.Name) + '_CommentsReport.csv',
      category: 'Comments',
      upsrc: Resources.resources.ICON_DOWNLOAD.src,
      buttonStyle: 'juno_button juno_button_filled juno_text_uppercase',
      endpoint: CrowdHub_App.CONFIG.BASE_URL + 'custom_api/api_analytics_exportActivityLog.php',
      text: CrowdHub_App.LANG.DOWNLOAD_COMMENTS,
    },
    {
      filename: encodeURI(content.Name) + '_QAReport.csv',
      category: 'QA Report',
      upsrc: Resources.resources.ICON_DOWNLOAD.src,
      buttonStyle: 'juno_button juno_button_filled juno_text_uppercase',
      endpoint: CrowdHub_App.CONFIG.BASE_URL + 'custom_api/api_analytics_exportActivityLog.php',
      text: CrowdHub_App.LANG.DOWNLOAD_QA,
    },
  ];
  const getAnalytics = button => {
    let downloadObject = {
      user_id: currentUser.Id,
      token: currentUser.Token,
      content_id: content.Id,
      start_date: dateObject.startDate,
      end_date: dateObject.endDate,
      filename: button.filename,
    };

    switch (button.text) {
      case CrowdHub_App.LANG.DOWNLOAD_DOWNLOADS:
        downloadObject.filters = JSON.stringify([{ name: 'Action', value: 'Download' }]);
        break;
      case CrowdHub_App.LANG.DOWNLOAD_META:
        downloadObject.filters = JSON.stringify([{ name: 'Category', value: 'Clicked' }]);
        break;
      case CrowdHub_App.LANG.DOWNLOAD_COMMENTS:
        if (
          content.FirstBucketName() == CrowdHub_App.BUCKET_OTSESSION ||
          content.FirstBucketName() == CrowdHub_App.BUCKET_GROUPOTSESSION
        ) {
          downloadObject.filters = JSON.stringify([{ name: 'Category', value: 'Chat' }]);
        } else {
          downloadObject.filters = JSON.stringify([{ name: 'Category', value: 'Commented' }]);
        }
        break;
      case CrowdHub_App.LANG.DOWNLOAD_QA:
        downloadObject.filters = JSON.stringify([{ name: 'Category', value: 'Q&A' }]);
        break;
      default:
        break;
    }

    App.INSTANCE.mApi.Request(
      button.endpoint,
      downloadObject,
      aData => {
        var confirmPopup = new ConfirmPopupPanel();

        if (aData.success == 'true') {
          confirmPopup.showOkConfirm('', CrowdHub_App.LANG.ANALYTICS_GENERATING_CSV, null);
        } else {
          confirmPopup.showOkConfirm('', CrowdHub_App.LANG.ANALYTICS_GENERATING_CSV_ON_ERROR, null);
        }
      },
      function (error) {
        var confirmPopup = new ConfirmPopupPanel();
        confirmPopup.showOkConfirm('', CrowdHub_App.LANG.ANALYTICS_GENERATING_CSV_ON_ERROR, null);
      },
    );
  };

  return (
    <>
      {downloadButtonsData.map((button, i) => {
        return (
          <motion.div whileHover={{ scale: 1.01 }} key={`downloadButton_${i}`}>
            <JUNOButton
              {...button}
              buttonIcon={FontAwesomeConfigurations.ICON_ARROW_DOWN_TO_BRACKET}
              onClick={() => {
                getAnalytics(button);
                firehoseAnalytics(button.filename);
                reportActivity(content.Id, button.category);
              }}
            ></JUNOButton>
          </motion.div>
        );
      })}
    </>
  );
};
export default DownloadsComponent;
